// Lightweight product references used by blog posts to embed inline product
// cards. Single source of truth so price/blurb/cover stay in sync with the
// shop. The full shop product objects (with bullets, descriptions, etc.) still
// live in ShopPage.jsx; this file mirrors only the fields a blog mini-card
// needs to render.
import { ETSY_LISTINGS, ETSY_SHOP_URL } from './etsy';

export const SHOP_PRODUCTS = {
  'calming-nervous-system-ebook': {
    id: 'calming-nervous-system-ebook',
    title: 'Calming the Nervous System',
    blurb: 'The complete field guide for regulating the body you live in. 22 modules, 50 protocols, 22 diagrams + a 30-day practice plan. Includes Pocket Flashcards Vol 1 free.',
    price: '$14.99',
    priceNote: 'Letter PDF · 2.8 MB · instant download',
    cover: '/calming-nervous-system-cover.jpg',
    coverBg: 'from-purple-700 to-indigo-800',
    borderColor: 'border-purple-200',
    ctaColor: 'bg-purple-600 hover:bg-purple-700',
    badge: 'Field Guide · Nervous System',
  },
  'pocket-flashcards-vol-1': {
    id: 'pocket-flashcards-vol-1',
    title: 'PocketHealth Flashcards · Vol 1',
    blurb: '50 evidence-based protocol cards. Each card: protocol · why · when · research. A4 print sheets, 4-up grid with cut guides.',
    price: '$4.99',
    priceNote: 'A4 PDF · 14 pages · instant download',
    cover: '/pocket-flashcards-v1-cover.jpg',
    coverBg: 'from-rose-200 to-purple-200',
    borderColor: 'border-pink-200',
    ctaColor: 'bg-pink-600 hover:bg-pink-700',
    badge: 'Flashcards · Nervous System',
  },
  '30-day-nervous-system-reset': {
    id: '30-day-nervous-system-reset',
    title: '30-Day Nervous System Reset',
    blurb: 'A 20-page A4 landscape standalone resource. 4 flagship diagrams, 25+ protocols across 6 categories, weekly deep-dives and a tickable 30-day calendar built around real habit-formation science.',
    price: '$5.99',
    priceNote: 'A4 Landscape PDF · 20 pages · instant download',
    cover: '/shop-images/30-day-nervous-system-reset.jpg',
    coverBg: 'from-indigo-100 via-purple-100 to-blue-100',
    borderColor: 'border-indigo-200',
    ctaColor: 'bg-indigo-600 hover:bg-indigo-700',
    badge: 'Habit Calendar · Nervous System',
  },

};

export const getProductCardData = (id) => SHOP_PRODUCTS[id];
export const getProductEtsyUrl = (id) => ETSY_LISTINGS[id] || ETSY_SHOP_URL;
